import React from 'react'

const style = {
  fontSize: '1.25em',
  lineHeight: 1.334,
  fontWeight: 400,
}

const SubHeadline = ({ children }: any) => <h3 style={style}>{children}</h3>

export default SubHeadline
